import { Action, createAction } from 'redux-act';

import { SeatedReservation } from '../../../models/interfaces/reservation/Reservation';
import TimestampPayload from '../TimestampPayload';
import ReservationPayload from './ReservationPayload';

export interface GuestArrivedPayload extends ReservationPayload {
  reservation: SeatedReservation;
}
export const guestArrived = createAction<GuestArrivedPayload>('GUEST_ARRIVED');
export type GuestArrivedActionType = Action<GuestArrivedPayload>;

export interface GuestArrivedSavedPayload extends TimestampPayload, ReservationPayload {
  reservation: SeatedReservation;
}
export const guestArrivedSaved = createAction<GuestArrivedSavedPayload>('GUEST_ARRIVED_SAVED');

export type GuestArrivedFailedPayload = TimestampPayload & ReservationPayload;
export const guestArrivedFailed = createAction<GuestArrivedFailedPayload>('GUEST_ARRIVED_FAILED');
